var app = angular.module("leonardo");

var PropertyStatisticsControllerDialog = function($scope, $rootScope, PropertyService, FilterService, $state, $filter,
                                                  RecurrenceService, TemplateService, $q, $timeout, ConfigThemeService) {
  $scope.property = {};
  $scope.tab = null;
  $scope.templateService = TemplateService;
  $scope.tab = 'past';
  $scope.property = $scope.ngDialogData.property;

  $scope.filters = {
    priority: FilterService.getFilter('priority'),
    category: FilterService.getFilter('category'),
    id: FilterService.getFilter('property_reports'),
    portfolio__id: FilterService.getFilter('portfolio_reports'),
    group: FilterService.getFilter('group_reports')
  };

  $scope.getCurrentValue = function (type) {
    return $scope.property.tasks_statistics[type] ?
      $scope.property.tasks_statistics[type].total : $scope.property.tasks_statistics.total[type];
  };

  $scope.goTo = function(location, priority) {
    $rootScope.$broadcast('no_reset_filters:updated', true);
    $timeout(function() {
      if (!isNull(priority)) {
        FilterService.setFilter('priority', priority.toString());
        var filters = FilterService.getFilter('filters') || [];
        filters = angular.isArray(filters) ? filters : filters.split(',');
        if (!filters.includes('priority')){
          filters.push('priority');
        }
        FilterService.setFilter('filters', filters.join(','));
      }
      FilterService.setProperty($scope.property).then(function () {
        $scope.closeThisDialog();
        $timeout(function (){
          $state.go(location);
        }, 100);
      });
    }, 0);
  };

  $scope.goToExpired = function(property) {
    $rootScope.$broadcast('no_reset_filters:updated', true);
    $timeout(function() {
      if(property){
        FilterService.setProperty(property).then(function () {
          $state.go('documents.expired');
          $scope.closeThisDialog();
        });
      }
    }, 0);
  };

  $scope.showTab = function(tab) {
    $scope.showHelp = false;
    $scope.tab = tab;
    var filters = angular.copy($scope.filters);
    if ($scope.property) {
      filters.id = $scope.property.id;
    }
    switch (tab) {
      case 'current':
        PropertyService.getStatistics(filters).then(function(data){
          assignProperty(data);
        });
        break;
      case 'past':
        PropertyService.getPastDue(filters).then(function(data){
          assignProperty(data);
        });
        break;
      case 'history':
        if (FilterService.hasFilter('date_range')) {
          filters.date_range = FilterService.getFilter('date_range');
        }
        else if (FilterService.hasFilter('from_date') || FilterService.hasFilter('to_date')) {
          filters.from_date = FilterService.getFilter('from_date');
          filters.to_date = FilterService.getFilter('to_date');
        }
        else {
          $scope.date_range = 'last_30_days';
          FilterService.setFilter('date_range', 'last_30_days');
          filters.date_range = FilterService.getFilter('date_range');
        }
        PropertyService.getHistory(filters).then(function(result){
          $scope.historyAll= {
            series: ['All'],
            labels: [],
            data: [],
            options: {
              title: {
                display: true,
                text: 'All Tasks %'
              },
              elements: {
                point: {
                  backgroundColor: 'rgba(42, 57, 78, 0.1)',
                  borderColor: 'rgba(42, 57, 78, 1)'
                },
                line: {
                  borderColor: 'rgba(42, 57, 78, 1)',
                  backgroundColor: 'rgba(42, 57, 78, 0.1)'
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: false
                  }
                }],
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                    max: 100
                  }
                }]
              }
            }
          };
          $scope.historyCritical = {
            series: ['Critical'],
            labels: [],
            data: [],
            options: {
              title: {
                display: true,
                text: 'Critical Tasks %'
              },
              elements: {
                point: {
                  backgroundColor: 'rgba(42, 57, 78, 0.1)',
                  borderColor: 'rgba(42, 57, 78, 1)'
                },
                line: {
                  borderColor: 'rgba(42, 57, 78, 1)',
                  backgroundColor: 'rgba(42, 57, 78, 0.1)'
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: false
                  }
                }],
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                    max: 100
                  }
                }]
              }
            }
          };
          $scope.historyDaily = {
            series: ['Daily'],
            labels: [],
            data: [],
            options: {
              title: {
                display: true,
                text: 'Daily Tasks %'
              },
              elements: {
                point: {
                  backgroundColor: 'rgba(42, 57, 78, 0.1)',
                  borderColor: 'rgba(42, 57, 78, 1)'
                },
                line: {
                  borderColor: 'rgba(42, 57, 78, 1)',
                  backgroundColor: 'rgba(42, 57, 78, 0.1)'
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: false
                  }
                }],
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                    max: 100
                  }
                }]
              }
            }
          };
          $scope.historyWeekly = {
            series: ['Weekly'],
            labels: [],
            data: [],
            options: {
              title: {
                display: true,
                text: 'Weekly Tasks %'
              },
              elements: {
                point: {
                  backgroundColor: 'rgba(42, 57, 78, 0.1)',
                  borderColor: 'rgba(42, 57, 78, 1)'
                },
                line: {
                  borderColor: 'rgba(42, 57, 78, 1)',
                  backgroundColor: 'rgba(42, 57, 78, 0.1)'
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: false
                  }
                }],
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                    max: 100
                  }
                }]
              }
            }
          };
          $scope.historyMonthly = {
            series: ['Monthly'],
            labels: [],
            data: [],
            options: {
              title: {
                display: true,
                text: 'Monthly Tasks %'
              },
              elements: {
                point: {
                  backgroundColor: 'rgba(42, 57, 78, 0.1)',
                  borderColor: 'rgba(42, 57, 78, 1)'
                },
                line: {
                  borderColor: 'rgba(42, 57, 78, 1)',
                  backgroundColor: 'rgba(42, 57, 78, 0.1)'
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    display: false
                  }
                }],
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                    max: 100
                  }
                }]
              }
            }
          };
          if (result.length > 0) {
            $scope.property = result[0];
            var date = '';
            angular.forEach($scope.property.tasks_statistics.critical, function(statistic, key) {
              date = moment(key, 'YYYYMMDD').format('MMM YYYY');
              $scope.historyCritical.labels.push(date);
              $scope.historyCritical.data.push($filter('number')(statistic.percent_completed, 0));
            });
            angular.forEach($scope.property.tasks_statistics.total, function(statistic, key) {
              $scope.historyAll.labels.push(moment(key, 'YYYYMMDD').format('MMM YYYY'));
              $scope.historyAll.data.push($filter('number')(statistic.percent_completed, 0));
            });
            angular.forEach($scope.property.tasks_statistics.daily, function(statistic, key) {
              $scope.historyDaily.labels.push(moment(key, 'YYYYMMDD').format('MMM DD, YYYY'));
              $scope.historyDaily.data.push($filter('number')(statistic.percent_completed, 0));
            });
            angular.forEach($scope.property.tasks_statistics.weekly, function(statistic, key) {
              var label = moment(key, 'YYYYMMDD').format('MMM YYYY') + ', ' +
                RecurrenceService.getWeek(moment(key, 'YYYYMMDD')) + ' week' ;
              $scope.historyWeekly.labels.push(label);
              $scope.historyWeekly.data.push($filter('number')(statistic.percent_completed, 0));
            });
            angular.forEach($scope.property.tasks_statistics.monthly, function(statistic, key) {
              $scope.historyMonthly.labels.push(moment(key, 'YYYYMMDD').format('MMM YYYY'));
              $scope.historyMonthly.data.push($filter('number')(statistic.percent_completed, 0));
            });
          }
        });
        break;
    }
  };

  function assignProperty(data) {
    var results = data.results ? data.results : data;
    if (results.length > 0) {
      $scope.property = results[0];
    }
  }

  $scope.getValue = function(status) {
    if (!status) return;
    var value = status.percent_completed;
    if ((status.completed == 0) && (status.total == 0)) {
      value = 0;
    }
    return value / 100;
  };

  $scope.getOptions = function(status, incolor) {
    if (!status) {
      return;
    }
    var options = {
      strokeWidth: 6,
      trailColor: ConfigThemeService.getColor('tertiaryColor', 0.2),
      color: (incolor || (status.total === 0)) ? ConfigThemeService.getColor('tertiaryColor', 0.2) : ConfigThemeService.config.theme_config.errorColor
    };
    if (!incolor && (status.total > 0)) {
      var value = status.progress_status;
      if (value == PropertyService.PROGRESS_STATUS_OK) {
        options['color'] = ConfigThemeService.config.theme_config.successColor;
      }
      else if (value == PropertyService.PROGRESS_STATUS_WARNING) {
        options['color'] = ConfigThemeService.config.theme_config.warningColor;
      }
    }
    return options;
  };

  $scope.getText = function(status) {
    if (!status) return;
    var value = status.percent_completed + '%';
    if ((status.completed == 0) && (status.total == 0)) {
      value = 'N/A';
    }
    return value;
  };

  $scope.$on('filter-service:filter-changed', function ($event, key) {
    uniquefilter(key);
  });

  $scope.$on('filter-service:filter-removed', function ($event, key) {
    uniquefilter(key);
  });

  function uniquefilter(key) {
    if (_.contains(['from_date', 'to_date'], key)) {
      $scope.showTab('history');
    }
  }

  $scope.showTab($scope.tab);

};

app.controller('PropertyStatisticsControllerDialog', ['$scope', '$rootScope', 'PropertyService', 'FilterService',
  '$state', '$filter', 'RecurrenceService', 'TemplateService', '$q', '$timeout', 'ConfigThemeService',
  PropertyStatisticsControllerDialog]);
